import { render, staticRenderFns } from "./AppDown.vue?vue&type=template&id=b64c0ad6&scoped=true"
import script from "./AppDown.vue?vue&type=script&lang=js"
export * from "./AppDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64c0ad6",
  null
  
)

export default component.exports